module.exports = __webpack_public_path__ + "media/5.cc40b427.mp3";